module.exports = __webpack_public_path__ + "static/img/s1bg.308d66d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/s1bg.png
// module id = x81Z
// module chunks = 0